import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.define-property";
import _some from "lodash/some";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { mappings as quickFactMappings } from '@nerdwallet/react-quick-facts';
import { BANKING_SUB_PRODUCT_TYPES } from '@nerdwallet/marketplace/constants';
import { getSubProductType } from '@nerdwallet/marketplace/selectors/common';
export default (function (_ref) {
  var marketplaceEntity = _ref.marketplaceEntity,
      _ref$marketplaceEntit = _ref.marketplaceEntitiesForCdApyTerms,
      marketplaceEntitiesForCdApyTerms = _ref$marketplaceEntit === void 0 ? {} : _ref$marketplaceEntit;
  var subProductType = getSubProductType(marketplaceEntity);
  var drivers;

  switch (subProductType) {
    case BANKING_SUB_PRODUCT_TYPES.CD:
      {
        /**
         * If no marketplaceEntitiesForCdApyTerms are supplied,
         * leverage APY supplied on the top, original marketplaceEntity
         */
        if (!_some(marketplaceEntitiesForCdApyTerms)) {
          drivers = [_objectSpread(_objectSpread({}, quickFactMappings.banking.getQuickFactAPY(marketplaceEntity)), {}, {
            description: null
          }), _objectSpread(_objectSpread({}, quickFactMappings.banking.getQuickFactMinimumBalance(marketplaceEntity)), {}, {
            label: 'Minimum Deposit',
            description: null // Omit since Default description is redundant with CTA.

          })];
        } else {
          drivers = [_objectSpread(_objectSpread({}, quickFactMappings.banking.getQuickFactAPY(marketplaceEntitiesForCdApyTerms.oneYear)), {}, {
            id: 'apy1Year',
            label: '1-year APY',
            description: null // Omit since we are displaying multiple APY's.

          }), _objectSpread(_objectSpread({}, quickFactMappings.banking.getQuickFactAPY(marketplaceEntitiesForCdApyTerms.threeYear)), {}, {
            id: 'apy3Year',
            label: '3-year APY',
            description: null // Omit since we are displaying multiple APY's.

          }), _objectSpread(_objectSpread({}, quickFactMappings.banking.getQuickFactAPY(marketplaceEntitiesForCdApyTerms.fiveYear)), {}, {
            id: 'apy5Year',
            label: '5-year APY',
            description: null // Omit since we are displaying multiple APY's.

          }), _objectSpread(_objectSpread({}, quickFactMappings.banking.getQuickFactMinimumBalance(marketplaceEntity)), {}, {
            label: 'Minimum Deposit',
            description: null // Omit since Default description is redundant with CTA.

          })];
        }

        break;
      }

    case BANKING_SUB_PRODUCT_TYPES.CASH_MANAGEMENT:
    case BANKING_SUB_PRODUCT_TYPES.CHECKING:
      drivers = [quickFactMappings.banking.getQuickFactMonthlyFee(marketplaceEntity), quickFactMappings.banking.getQuickFactAPY(marketplaceEntity), quickFactMappings.banking.getQuickFactBonus(marketplaceEntity)];
      break;

    case BANKING_SUB_PRODUCT_TYPES.MONEY_MARKET:
    case BANKING_SUB_PRODUCT_TYPES.SAVINGS:
      drivers = [quickFactMappings.banking.getQuickFactAPY(marketplaceEntity), quickFactMappings.banking.getQuickFactBonus(marketplaceEntity)];
      break;

    default:
      break;
  }

  return {
    drivers: drivers
  };
});